import { Months, Utils, Days, Users } from "../Const";

/**
 * Renvoie les données pour le graphique "Nombre de nouveaux étudiants et alumni par mois dans RéseauPro"
 *
 * ! Données FAKE
 *
 * @return {NivoBarChartData} - Tableau de données pour Nivo
 */
export function getStudentsByMonthByUniversityData() {
  const chartData = [];
  const months = Months.all;

  months.forEach((month) => {
    chartData.push({
      Date: month,
      Étudiants: Utils.generateData(1, 50, 400)[0],
      Alumni: Utils.generateData(1, 50, 400)[0],
    });
  });

  return chartData;
}

/**
 * Renvoie les données du nombre d'étudiants par profil (licence, master, doctorat, etc.)
 *
 * ! Données FAKE
 *
 * @returns {NivoPieChartData} - Tableau de données pour Nivo
 */
export function getStudentsByProfileData() {
  const chartData = [];
  const profiles = Users.usersProfiles;

  profiles.forEach((profile) => {
    chartData.push({
      label: profile,
      id: profile,
      value: Utils.generateData(1, 50, 1000)[0],
    });
  });

  return chartData;
}

/**
 * Renvoie les données du nombre d'étudiants par profil (licence, master, doctorat, etc.) par jour
 *
 * ! Données FAKE
 *
 * @returns {NivoBarChartData} - Tableau de données pour Nivo
 */
export function getStudentsByProfileDailyData() {
  const chartData = [];
  const profiles = Users.usersProfiles;
  const days = Days.lastSevenDays;

  days.forEach((day) => {
    const data = {
      Date: day,
    };

    profiles.forEach((profile) => {
      data[profile] = Utils.generateData(1, 50, 100)[0];
    });

    chartData.push(data);
  });

  return chartData;
}
